import { CalendarEvent } from '@/types/calendar';

import CalendarEventCreateModal from '@/components/calendar/CalendarEventCreateModal';

interface CommunityCalendarEventCreateModalProps {
  onClose: () => void;
  communityId: number;
  initialDate?: Date | null;
  onEventCreated?: (event: CalendarEvent) => void;
}

const CommunityCalendarEventCreateModal = ({
  onClose,
  communityId,
  initialDate,
  onEventCreated,
}: CommunityCalendarEventCreateModalProps) => {
  // Create a custom form data handler for community events
  const handleEventCreated = (event: CalendarEvent) => {
    if (onEventCreated) {
      onEventCreated(event);
    }
  };

  return (
    <CalendarEventCreateModal
      onClose={onClose}
      propertyLocationId={0} // Set to 0 for community events (will be handled as null in backend)
      communityId={communityId} // Pass the community ID
      initialDate={initialDate}
      onEventCreated={handleEventCreated}
    />
  );
};

export default CommunityCalendarEventCreateModal;
